import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';
import useSWR from 'swr';
import { route } from 'nextjs-routes';
import { useBulkJobId } from './use-bulk-job-id';
import { useStore } from './use-store';

/**
 */

export const useBulkJob = () => {
  const bulkJobId = useBulkJobId();
  const [{ insuredId }] = useStore();

  /**
   */
  const { data, mutate, isValidating } = useSWR(
    bulkJobId
      ? [
          route({
            pathname: '/api/v2/bulk_jobs/[id]',
            query: { id: bulkJobId },
          }),
          insuredId,
        ]
      : null,
    async ([url]) => {
      const res = await FrontendHttpClient.get(url);
      return res.data;
    }
  );

  return {
    data,
    bulkJobId,
    mutate,
    isValidating,
  };
};
